import React, { Component } from 'react'
import { Collapse, Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTx } from '../../actions'
import { fetchRelatedTransactions, resetFetchRelatedTransactions } from '../../actions/related_transactions'
import { formatTimeString } from '../../utils/formatters'
import Spinner3Bounce from '../spinner_3_bounce'

class RelatedTransactions extends Component {
  state = {
    open: false,
  }

  onOpen = () => {
    if (!this.state.open) {
      const phoneNumbers = this.props.userTx.transaction_identity.identity_phone_numbers.map((i) => i.phone_number)
      this.props.resetFetchRelatedTransactions()
      if (phoneNumbers.length) {
        this.props.fetchRelatedTransactions(phoneNumbers[0])
      }
    }
    this.setState({ open: !this.state.open })
  }
  render() {
    const { state, props } = this
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const borderRadius = state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'

    const { relatedTransactions, isFetching } = props
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: borderRadius, cursor: 'pointer' }} onClick={this.onOpen} className='ibox-title'>
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Phone Number Related Transaction</header>
        </div>
        <Collapse in={state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {relatedTransactions.length ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Phone Number</th>
                      <th>Created</th>
                      <th>Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    {relatedTransactions.map((entry) => (
                      <tr key={entry.id}>
                        <td>{entry.id}</td>
                        <td>
                          {entry.transaction_identity.identity_phone_numbers.map((phone, index) => (
                            <div key={index}>{phone.phone_number}</div>
                          ))}
                        </td>
                        <td>{formatTimeString(entry.created)}</td>
                        <td>{formatTimeString(entry.updated)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <>
                  {isFetching ? (
                    <div className='text-center'>
                      <Spinner3Bounce isActive />
                    </div>
                  ) : (
                    <span>{'N/A'}</span>
                  )}
                </>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  userTx: state.txById.userTx,
  isFetching: state.fetchRelatedTransactions.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUsersTx,
      fetchRelatedTransactions,
      resetFetchRelatedTransactions,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RelatedTransactions))
